import React from 'react';

import DisplayChart from './DisplayChart';
import DashboardContext from '../DashboardContext';
import { Typography } from '@material-ui/core';
import ChartContext from '../../charts/ChartContext';

import { makeStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import SubContext from '../../subs/SubContext';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  content: {
    flexGrow: 1,
  },
  hide: {
    margin: theme.spacing(1),
  },
}));

const DisplayDashboard = () => {
  const ctx = React.useContext(DashboardContext);
  const subCtx = React.useContext(SubContext);
  const chartCtx = React.useContext(ChartContext);
  const [hide, setHide] = React.useState(false);
  const setDateFilter = chartCtx.setDateFilter;
  const classes = useStyles();

  React.useEffect(() => {
    setHide(false);
  }, [ctx.selectedDashboard]);

  const handleSelect = React.useCallback(
    (event) => setDateFilter(event.target.value),
    [setDateFilter]
  );

  const handleCheck = (event) => {
    setHide(event.target.checked);
  };

  if (!subCtx.selectedSub) {
    return (
      <Typography variant="h6" className={classes.formControl}>
        Select a Subscriber
      </Typography>
    );
  }

  if (!ctx.selectedDashboard) {
    return (
      <Typography variant="h6" className={classes.formControl}>
        Select a Dashboard
      </Typography>
    );
  }

  if (chartCtx.charts.length === 0) {
    return (
      <Typography variant="h6" className={classes.formControl}>
        {ctx.selectedDashboard} Dashboard - No Charts
      </Typography>
    );
  }

  return (
    <div>
      <Typography display="inline" variant="h6" className={classes.formControl}>
        {ctx.selectedDashboard} Dashboard - Charts
      </Typography>
      <br />
      <FormControl color="secondary" className={classes.formControl}>
        <InputLabel id="demo-simple-select-outlined-label">
          Filter by Date
        </InputLabel>
        <Select
          labelId="demo-simple-select-outlined-label"
          id="demo-simple-select-outlined"
          value={chartCtx.dateFilter}
          onChange={handleSelect}
          label="Filter by Date"
        >
          <MenuItem value="" />
          <MenuItem value={'today'}>Today</MenuItem>
          <MenuItem value={'yesterday'}>Yesterday</MenuItem>
          <MenuItem value={'weekly'}>Last 7 Days</MenuItem>
          <MenuItem value={'monthly'}>Last 30 Days</MenuItem>
          <MenuItem value={'ytd'}>YTD</MenuItem>
          <MenuItem value={'yearly'}>Last Year</MenuItem>
        </Select>
      </FormControl>{' '}
      <br />
      <FormControlLabel
        align="right"
        className={classes.hide}
        control={
          <Checkbox color="primary" checked={hide} onChange={handleCheck} />
        }
        label={<span style={{ fontSize: '15px' }}>Hide Charts</span>}
        labelPlacement="start"
      />
      <br />
      {!hide ? (
        <div>
          {chartCtx.charts.map((chart, index) => (
            <DisplayChart
              key={index}
              filter={chart.filter}
              name={chart.chartName}
              chartId={chart.chartId}
              chartIdYear={chart.chartIdYear}
              chartHeight={chart.height}
              chartWidth={chart.width}
              subFilterField={chart.filter.subscriber}
              dateField={chart.filter.date}
              showAttribution={chart.showAttribution}
              refreshInterval={chart.refreshInterval}
            ></DisplayChart>
          ))}
        </div>
      ) : null}
    </div>
  );
};

export default DisplayDashboard;
